import { 
  FETCH_NOTIFICATIONS_FAILURE, 
  FETCH_NOTIFICATIONS_REQUEST, 
  FETCH_NOTIFICATIONS_SUCCESS, 
  CLEAR_NEW_NOTIFICATIONS, 
  FETCH_UNSEEN_NOTIFICATIONS_SUCCESS, 
  MARK_NOTIFICATIONS_AS_SEEN 
} from "redux/actions/actiontype";

const initialState = {
  notifications: [],
  loading: false,
  error: null,
  newNotificationsCount: 0,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_NOTIFICATIONS_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        notifications: action.payload 
      };

    case FETCH_UNSEEN_NOTIFICATIONS_SUCCESS:
      return { ...state, newNotificationsCount: action.payload };

    case FETCH_NOTIFICATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

      case MARK_NOTIFICATIONS_AS_SEEN:
        return {
          ...state,
          notifications: state.notifications.map((notif) => ({
            ...notif,
            seen: true,
          })),
          newNotificationsCount: 0,
        };

    case 'MARK_NOTIFICATION_SEEN_LOCALLY':
      const newlySeenIds = new Set(action.payload);
      const updatedNotifications = state.notifications.map((notif) =>
        newlySeenIds.has(notif.id) ? { ...notif, seen: true } : notif
      );
      const unseenNowSeen = state.notifications.filter(
        (notif) => newlySeenIds.has(notif.id) && !notif.seen
      ).length;

      return {
        ...state,
        notifications: updatedNotifications,
        newNotificationsCount: Math.max(0, state.newNotificationsCount - unseenNowSeen),
      };

    case CLEAR_NEW_NOTIFICATIONS:
      return { ...state, newNotificationsCount: 0 };

    default:
      return state;
  }
};

export default notificationReducer;
